import React, {useState, ReactElement} from 'react';
import MidScreenModal, {
  ModalAnimateDirection,
} from '../../../components/modal/MidScreenModal';
import unlockOfferLockIcon from '../../../assets/images/unlock.svg';
import topNavOffersIcon from '../../../assets/images/top_nav_offers_small.svg';
import backRedIcon from '../../../assets/images/back_arrow_red.svg';
import moment from 'moment';

enum SlideDirection {
  RIGHT,
  LEFT,
  NONE,
}

type offerType = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};

type offerModalType = {
  offer?: offerType | null;
  onClose: () => void;
  open?: boolean;
};

const OfferModal = ({offer, onClose, open}: offerModalType): ReactElement => {
  const getValidity = (validity: string | undefined) => {
    return moment(validity).format('DD MMM YYYY');
  };

  const [animateStyles, setAnimateStyles] = useState<any>({});

  return (
    <MidScreenModal
      isVisible={open}
      onClose={onClose}
      animate={true}
      animateDirection={ModalAnimateDirection.RIGHT_TO_LEFT}>
      <div className="overflow-x-hidden p-4">
        <div
          className={`transition transform views-wrapper`}
          style={{...animateStyles}}>
          {/* style={{...animateStyles}}> */}
          <div className="float-left">
            <OfferView
              offer={offer}
              onTncClick={
                () => console.log('clicked')
                //setAnimateStyles({'--tw-translate-x': '-20rem'})
              }
            />
          </div>
          <div className="float-right">
            <TermsConditionsView
              onBackClick={() => setAnimateStyles({'--tw-translate-x': '0rem'})}
              animationDirection={SlideDirection.LEFT}
            />
          </div>
          <div className="clear-both"></div>
        </div>
      </div>
    </MidScreenModal>
  );
};

interface TermsConditionsProps {
  onBackClick: () => void;
  animationDirection?: SlideDirection;
}

const TermsConditionsView = ({
  onBackClick,
  animationDirection = SlideDirection.NONE,
}: TermsConditionsProps): ReactElement => {
  const animateClasses: string =
    animationDirection == SlideDirection.NONE
      ? ''
      : animationDirection == SlideDirection.LEFT
      ? 'animate__slideInRight'
      : 'animate__slideOutRight';

  return (
    <div className={`w-72 tnc-view grid grid-col`}>
      <div
        onClick={onBackClick}
        className="text-red-600 font-bold text-left flex">
        <img src={backRedIcon} alt="Back" />
        &nbsp; Back
      </div>
      <div className="my-6 text-big">Terms and conditions</div>
      <div className="text-small">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam, nisi
        mollitia perspiciatis aperiam ut officia doloremque nesciunt sit
        cupiditate maxime? Aliquam veritatis nemo quo dolore exercitationem
        nobis, qui aperiam voluptatem?
      </div>
      <div className="text-small">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam, nisi
        mollitia perspiciatis aperiam ut officia doloremque nesciunt sit
        cupiditate maxime? Aliquam veritatis nemo quo dolore exercitationem
        nobis, qui aperiam voluptatem?
      </div>
    </div>
  );
};

const getValidity = (validity: string | undefined) => {
  return moment(validity).format('YYYY-MM-DD HH:mm:ss');
};

interface OfferViewProps {
  offer?: offerType | null;
  onTncClick: () => void;
  animationDirection?: SlideDirection;
}

const OfferView = ({
  offer,
  onTncClick,
  animationDirection = SlideDirection.NONE,
}: OfferViewProps): ReactElement => {
  const animateClasses: string =
    animationDirection == SlideDirection.NONE
      ? ''
      : animationDirection == SlideDirection.LEFT
      ? 'animate__slideOutLeft'
      : 'animate__slideInLeft';

  return (
    <div
      className={`w-72 offer-view flex flex-col items-center justify-center`}>
      <div className="">
        <img src={unlockOfferLockIcon}></img>
        {/* <div className="text-base font-bold">{offer?.type}</div> */}
        {/* <div className="text-sm mt-0.5">{offer?.discount}</div> */}
      </div>
      <div className="mt-5 w-full">
        <div className="text-xl mb-5">Your offer unlocked!</div>
        <div className="font-bold font-roboto  flex justify-center">
          <span>This coupon will be stored in</span>
          <span>
            <img src={topNavOffersIcon} />
          </span>
        </div>
        <div className="text-xs">
          Redeem at self checkout or billing counter
        </div>
        <div className="mt-4 border-2 border-dotted shadow-md rounded-xl border-very_light_purple w-full py-3 text-lg font-medium bg-very_light_gray">
          {offer?.couponCode}
        </div>
        <div className="mt-4 mb-2">{offer?.description}</div>
        <div className="text-tiny m-1.5 text-royal_blue">
          <span className="">Valid till:&nbsp;</span>
          <span className="">{getValidity(offer?.validity)}</span>
        </div>
      </div>
      {/* <div
        className=" mt-5 text-red-600 font-roboto font-bold"
        onClick={onTncClick}>
        T&C Apply
      </div> */}
    </div>
  );
};

export default OfferModal;
